export default "__VITE_ASSET__CUpPR5pL__"